import { default as cookies } from '_cookies.js';

const bubbleSets = document.querySelectorAll('[data-bubble-images]');

/**
 * 
 */
const init = function () {

	if ( bubbleSets ) setupBubbleImages()

};


/**
 *
 */
const setupBubbleImages = function () {

	bubbleSets.forEach( bubbleSetImageElement => {

    const imageData   = JSON.parse( bubbleSetImageElement.getAttribute('data-bubble-images') )
    const cookieName  = bubbleSetImageElement.closest('.acf-bubble-feature').getAttribute('id')
    let   cookieValue = cookies.getCookie( cookieName ) ? parseInt( cookies.getCookie( cookieName ) ) : 0
    
    if ( parseInt( cookieValue ) > ( imageData.length - 1 ) ) cookieValue = 0

    bubbleSetImageElement.setAttribute( 'src', imageData[cookieValue].src )
    bubbleSetImageElement.setAttribute( 'alt', imageData[cookieValue].alt )

    const figcaption = bubbleSetImageElement.nextElementSibling

    if ( figcaption && imageData[cookieValue].caption.length ) {
      figcaption.style.display = 'block'
      figcaption.textContent = imageData[cookieValue].caption
    } else if ( figcaption ) {
      figcaption.style.display = 'none'
      figcaption.textContent = ''
    }

    cookieValue = parseInt( cookieValue ) + 1
    cookies.setCookie( cookieName, cookieValue, 999 )
    bubbleSetImageElement.classList.add( 'is-initialized' )

	});

};

const api = {
	init: init
};

export default api;